import { createApi } from "@reduxjs/toolkit/query/react";

import { axiosBaseQuery } from "@/api/base";
import { Transaction, TxType } from "@/types/transaction";

const TAG = "transactions";

export const transactionsApi = createApi({
  baseQuery: axiosBaseQuery({ baseUrl: "/pf-document/" }),
  reducerPath: "transactionsApi",
  tagTypes: [TAG],
  endpoints: builder => ({
    getTransactions: builder.query<Transaction[], { perPage: number; txType: TxType }>({
      providesTags: [TAG],
      query: ({ perPage, txType }) => ({
        url: "recent-transactions",
        method: "GET",
        params: {
          n: perPage,
          tx_type: txType,
        },
      }),
    }),
  }),
});

export const { useGetTransactionsQuery } = transactionsApi;
